<template>
  <span class="flowmap-box">
    <el-progress :text-inside="true" :percentage="perfPercentage" :color="eventColor" :class="[getClass]"/>
  </span>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WFlowMapProgressbar',
  props: {
    perfRecords: {
      type: Object,
    },
    perfKey: {
      type: String,
    },
  },
  data() {
    return {
      hasEvent: false,
      eventColor: '#5a9ee4',
    };
  },
  updated() {
    const key = this.perfKey;
    const records = this.perfRecords;
    const eventInfo = this.$store.getters.eventlevelInfo;

    const eventlevelId = records[`${key}/EVENTLEVEL_ID`];
    if (isNil(eventlevelId)) {
      return;
    }

    this.hasEvent = !(eventlevelId === 'NM');
    if (!isEmpty(eventInfo[eventlevelId])) {
      this.eventColor = eventInfo[eventlevelId].eventlevelColorBg;
    }
  },
  computed: {
    perfPercentage() {
      if (isNil(this.perfKey)) {
        return 0;
      }
      const perfData = this.perfRecords[this.perfKey];
      // FIXME:  성능 값이 없을 경우 어떻게 표현? 일단 0%으로 표현.
      if (isNil(perfData) || perfData === -1) {
        return 0;
      }

      return parseFloat((perfData * 100).toFixed(2));
    },
    getClass() {
      const eventlevelId = this.perfRecords[`${this.perfKey}/EVENTLEVEL_ID`];
      if (eventlevelId === 'NM' || isNil(eventlevelId)) {
        return null;
      }

      return 'caution';
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapProgressbar.vue